import axios from 'axios'
import qs from 'qs'
import { Dialog, Toast } from 'vant'
import { getToken } from '@/utils/tools'
import verConfig from './verConfig'
import { router } from '../router'
import i18n, { getLanguage } from "@/i18n"

// export const domain = 'https://trmudo.com/'
export const domain = verConfig.url
export const isLinkGame = verConfig.isLinkGame || false;

// import config from './env.js'
// import { Message, MessageBox } from 'element-ui'
// import FileSaver from 'file-saver'
// const Toast = (message) => Message({ message, type: 'error' })

/* Create a new instance of axios with a custom config */
const token = getToken();
const interceptResponse = (res) => {
  if (res.data.code === '000040') {
    // Invalid login
    Dialog.alert({
      title: i18n.t('networkError.warning'),
      message: i18n.t('networkError.sessionExpired'),
      confirmButtonText: i18n.t('Button.confirm'),
    }).then(() => router.replace('/login'))

    return Promise.reject(res.data)
  } else {
    return res
  }
}

/* Network Error Message */
const ERROR_MESSAGE = {
  400: 'networkError.badRequest',
  401: 'networkError.unauthorized',
  402: 'networkError.paymentRequired',
  403: 'networkError.forbidden',
  404: 'networkError.notFound',
  405: 'networkError.methodNotAllowed',
  406: 'networkError.notAcceptable',
  500: 'networkError.serverError',
  501: 'networkError.notImplemented',
  502: 'networkError.badGateway',
  503: 'networkError.serviceUnavailable',
  504: 'networkError.gatewayTimeout',
  // REQUEST_ERROR: '发送请求时出现错误',
  REQUEST_ERROR: 'networkError.requestError',
  // NO_RESPONDING: '服务器无响应',
  NO_RESPONDING: 'networkError.noResponse',
  // UNKNOWN_ERROR: '未知错误',
  UNKNOWN_ERROR: 'networkError.unknown',
}



const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? `/api` : `${domain}/api`,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
    'token': token,
    "lang": getLanguage()
  },
  paramsSerializer: (params) => qs.stringify(params, {
    skipNulls: true
  }),
  timeout: 60000,
  // withCredentials: true,
  withCredentials: false,
  responseType: 'json', // default
  validateStatus: (status) => status >= 200 && status < 300, // default
})

/* Add a request interceptor */
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    config.headers.lang = getLanguage()
    return config
  },
  (error) => {
    // Do something with request error
    Toast(i18n.t(ERROR_MESSAGE.REQUEST_ERROR))
    return Promise.reject(error)
  }
)

/* Add a response interceptor */
service.interceptors.response.use(
  (response) => {
    // Do something with response data
    const { ret, msg } = response.data
    if (ret === -1) {
      // Toast(msg)
      // setTimeout(()=> {
      if (verConfig.notLoginToRegist) {
        return router.replace("/login");
      }
      router.replace("login")
      // },1000)
      return
    }
    return interceptResponse(response)
  },
  (error) => {
    // Do something with response error
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const status = error.response.status
      // eslint-disable-next-line no-prototype-builtins
      if (ERROR_MESSAGE.hasOwnProperty(status)) {
        Toast(`${status} ${i18n.t(ERROR_MESSAGE[status])}`)
      } else {
        Toast(i18n.t(ERROR_MESSAGE.UNKNOWN_ERROR))
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      Toast(i18n.t(ERROR_MESSAGE.NO_RESPONDING))
    } else {
      // Something happened in setting up the request that triggered an Error
    }
    return Promise.reject(error)
  }
)

export const $get = (url, params) => service({
  url,
  method: 'get',
  params: (() => {
    if (!params) {
      params = new Object;
    }
    // params.lang = verConfig.lan || "en";
    return params
  })(),
  headers: {
    token: localStorage.getItem('token')
  }
})

export const $post = (url, data, params, mytoken, headers) =>
  service({
    url,
    method: 'post',
    headers: {
      'token': mytoken ? mytoken : localStorage.getItem('token')
    },
    params,
    data: (() => {
      if (!data) {
        data = new Object;
      }
      // data.lang = verConfig.lan || "en";
      return data
    })(),
  })

const uploadHeaders = { lang: getLanguage(), "Content-Type": "multipart/form-data", token: token }
export const $upload = ({ url = "/users/upload", data, name = "image", headers }) => new Promise(async (resolve, reject) => {
  try {
    const res = await service({ url, data, method: "POST", headers: { ...uploadHeaders, ...headers }, })
    resolve(res.data)
  } catch (error) {
    reject(error)
  }
})
